import { combineReducers } from 'redux';
import { articlesApi } from '../api/articlesApi';
import articleUiReducer from '../slices/articleUiSlice';
import { accreditationReducer } from './accreditationReducer';
import { annualRenewalsReducer } from './annualRenewalsReducer';
import asiaPopupReducer from './asiaPopupReducer';
import contactModalReducer from './contactModalReducer';
import contactReducer from './contactReducer';
import ebriefingModalReducer from './ebriefingModalReducer';
import { eventsReducer } from './eventsReducer';
import feedbackModalReducer from './feedbackFormModalReducer';
import formWizardReducer from './formWizardReducer';
import pageReducer from './pageReducer';
import siteReducer from './siteReducer';
import staffEnquiryFormModalReducer from './staffEnquiryFormModalReducer';
import weChatPopupReducer from './weChatPopupReducer';

export default combineReducers({
  page: pageReducer,
  siteOptions: siteReducer,
  contactModal: contactModalReducer,
  ebriefingModal: ebriefingModalReducer,
  feedbackFormModal: feedbackModalReducer,
  staffEnquiryFormModal: staffEnquiryFormModalReducer,
  formWizard: formWizardReducer,
  contactbar: contactReducer,
  events: eventsReducer,
  articleUi: articleUiReducer,
  [articlesApi.reducerPath]: articlesApi.reducer,
  accreditation: accreditationReducer,
  annualRenewals: annualRenewalsReducer,
  asiaPopup: asiaPopupReducer,
  weChatPopup: weChatPopupReducer,
  nonce: (state = null) => state,
});
